var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomAidata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M832 341.333333v149.333334h-128v-149.333334h-42.666667v149.333334h-128v-149.333334h-42.666666v149.333334h-149.333334v42.666666h149.333334v128h-149.333334v42.666667h149.333334v128h-149.333334v42.666667h533.333334V341.333333h-42.666667z m0 192v128h-128v-128h128z m-298.666667 0h128v128h-128v-128z m0 170.666667h128v128h-128v-128z m170.666667 128v-128h128v128h-128z",
    fill: "#90CAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M853.333333 170.666667H170.666667v682.666666h170.666666V341.333333h512z",
    fill: "#00BCD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.333333 149.333333v725.333334h213.333334V362.666667h512V149.333333H149.333333z m42.666667 341.333334v-128h128v128H192z m128 42.666666v128H192v-128h128z m42.666667-341.333333h128v128h-128V192z m170.666666 0h128v128h-128V192zM320 192v128H192V192h128zM192 832v-128h128v128H192z m640-512h-128V192h128v128z",
    fill: "#0097A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomAidata);
export default __webpack_public_path__ + "static/media/custom-aidata.3ea81c623d983d76e80f76d08a8f03cf.svg";
export { ForwardRef as ReactComponent };